import { alpha } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { useContext } from "react";
import { Controller } from "react-hook-form";
import useLocales from "src/hooks/useLocales";

import Context from "../../../Products/context";

type Props = {
	control: any;
	name: string;
};

export default function CustomBirthDateSelector({ control, name }: Props) {
	const { translate } = useLocales();
	const { theme } = useContext(Context);

	return (
		<Controller
			control={control}
			name={name}
			render={({ field, fieldState: { error } }) => (
				<DatePicker
					disableFuture
					label={translate("Fecha de nacimiento")}
					maxDate={moment().add(-18, "years")}
					minDate={moment().add(-100, "years")}
					slotProps={{
						day: {
							sx: {
								"&.Mui-selected:focus": {
									backgroundColor: theme?.colors.primary
								},
								"&.Mui-selected": {
									backgroundColor: theme?.colors.primary
								},
								"&.Mui-selected:hover": {
									backgroundColor: theme?.colors.primary
								}
							}
						},
						yearButton: {
							sx: {
								"&.Mui-selected:focus": {
									backgroundColor: theme?.colors.primary
								},
								"&.Mui-selected": {
									backgroundColor: theme?.colors.primary
								},
								"&.Mui-selected:hover": {
									backgroundColor: theme?.colors.primary
								}
							}
						},
						textField: {
							fullWidth: true,
							variant: "outlined",
							error: !!error,
							helperText: error?.message,
							sx: {
								"& .MuiOutlinedInput-root": {
									"& fieldset": {
										borderColor: alpha(theme?.colors.stroke ?? "", 0.3)
									},
									"&:hover fieldset": {
										borderColor: !!error ? theme?.colors.mainError : theme?.colors.primary
									},
									"&.Mui-focused fieldset": {
										borderColor: !!error ? theme?.colors.mainError : theme?.colors.primary
									},
									"& input": {
										color: theme?.colors.primaryText
									}
								}
							},
							InputLabelProps: {
								style: {
									color: !!error
										? theme?.colors.mainError
										: alpha(theme?.colors.secondaryText ?? "", 0.8)
								}
							},
							FormHelperTextProps: {
								style: {
									color: !error ? theme?.colors.secondaryText : theme?.colors.mainError
								}
							}
						}
					}}
					{...field}
				/>
			)}
		/>
	);
}
